export const ptPT = {
  // jobs
  'job.caixa': 'Caixa',
  'job.escritorio': 'Escritório',
  'job.gestor': 'Gestor',
  'job.director': 'Director',
  'job.ceo': 'CEO',

  // actions
  'action.dormir': 'Dormir',
  'action.comer-em-casa': 'Comer em casa',
  'action.estudar-em-casa': 'Estudar em casa',
  'action.trabalhar': 'Trabalhar',
  'action.candidatar-se': 'Candidatar-se a emprego',
  'action.estudar': 'Estudar',
  'action.comprar-comida': 'Comprar 5 refeições',
  'action.comprar-fato': 'Comprar fato',
  'action.beber': 'Beber no bar',
  'action.comer-no-bar': 'Comer no bar',
  'action.socializar': 'Socializar',

  // locations
  'location.casa': 'Casa',
  'location.trabalho': 'Trabalho',
  'location.escola': 'Escola',
  'location.loja': 'Loja',
  'location.bar': 'Bar',

  // education levels (0..5)
  'education.0': 'sem escolaridade',
  'education.1': 'básico',
  'education.2': 'secundário',
  'education.3': 'licenciatura',
  'education.4': 'mestrado',
  'education.5': 'doutoramento',

  // weekdays
  'weekday.seg': 'seg',
  'weekday.ter': 'ter',
  'weekday.qua': 'qua',
  'weekday.qui': 'qui',
  'weekday.sex': 'sex',
  'weekday.sab': 'sab',
  'weekday.dom': 'dom',

  // error codes (reducer)
  'error.dead': 'morto',
  'error.gameOver': 'fim de partida',
  'error.wrongLocation': 'acção exige estar em {location}',
  'error.closed': '{location} fechado',
  'error.noJob': 'precisa de emprego',
  'error.noFood': 'sem comida em casa',
  'error.noTargetJob': 'falta o emprego alvo',
  'error.mustApplyNext': 'só podes candidatar-te ao cargo imediatamente acima',
  'error.lowEducation': 'educação insuficiente para {job}',
  'error.daysRequired': 'precisa de {needed} dia(s) completo(s) no cargo actual (tens {current})',
  'error.sameLocation': 'já estás aí',
  'error.alreadyHasSuit': 'já tens fato',
  'error.noSuit': 'precisa de fato (compras na loja) para {job}',
  'error.noMoney': 'sem dinheiro',

  // hud
  'hud.day': 'Dia',
  'hud.score': 'Score',
  'hud.location': 'Local ({hours})',

  // tabs
  'tab.travel': 'Viajar',

  // stats
  'stat.energy': 'Energia',
  'stat.happiness': 'Felicidade',
  'stat.hunger': 'Fome',

  // meta
  'meta.job': 'Emprego',
  'meta.education': 'Educação: {xp} XP — L{level} {levelName}',
  'meta.fridge.one': 'Frigorífico: {count} refeição',
  'meta.fridge.other': 'Frigorífico: {count} refeições',
  'meta.daysForPromotion': '({current}/{needed} dias p/ {target})',
  'meta.hasSuit': '✓ Fato',

  // work warning
  'work.done': '✓ {start}-{end}h cumprido ({hours}/{max}h core)',
  'work.willClearWarning': ' — aviso vai ser limpo à meia-noite',
  'work.coreEndedWarn': '⚠ Só trabalhaste {hours}/{max}h core ({start}-{end}h). À meia-noite recebes 1 aviso',
  'work.coreEndedDemote': '⚠ Só trabalhaste {hours}/{max}h core ({start}-{end}h). À meia-noite vais ser DESPROMOVIDO',
  'work.progress': 'Hoje: {hours}/{max}h core ({start}-{end}h) • trabalho aberto {openLabel}',
  'work.warningPrefix': '⚠ Tens 1 aviso. ',

  // action button (candidatar-se)
  'action.applyLabel': 'Candidatar-se a {job} ({wage}/h{requirement})',
  'action.applyRequirement.one': ' • requer {days} dia {previous}',
  'action.applyRequirement.other': ' • requer {days} dias {previous}',

  // game over
  'gameover.titleDead': 'GAME OVER',
  'gameover.titleEnd': 'FIM DE PARTIDA',
  'gameover.reasonDead': 'Não sobreviveste aos 30 dias.',
  'gameover.reasonEnd': 'Completaste os 30 dias.',
  'gameover.breakdown.money': 'Money',
  'gameover.breakdown.education': 'Education',
  'gameover.breakdown.happiness': 'Happiness',
  'gameover.breakdown.job': 'Job',
  'gameover.newGame': 'Nova partida',

  // leaderboard
  'leaderboard.title': 'Leaderboard',
  'leaderboard.submitPrompt': 'Submeter o teu score?',
  'leaderboard.namePlaceholder': 'O teu nome',
  'leaderboard.feedbackLabel': 'Feedback',
  'leaderboard.feedbackOptional': 'opcional',
  'leaderboard.feedbackPlaceholder': 'O que gostaste? O que podemos melhorar?',
  'leaderboard.submit': 'Submeter',
  'leaderboard.submitting': 'A submeter…',
  'leaderboard.checking': 'A verificar se entras no top 100…',
  'leaderboard.skip': 'Saltar',
  'leaderboard.invalidName': 'Nome tem de ter 3-24 chars (letras, números, _ - espaço)',
  'leaderboard.submitFailed': 'Falha ao submeter: {reason}',
  'leaderboard.yourRank': 'Posição #{rank}',
  'leaderboard.viewAll': 'Ver leaderboard',
  'leaderboard.close': 'Fechar',
  'leaderboard.loading': 'A carregar…',
  'leaderboard.empty': 'Sem scores ainda — sê o primeiro!',
  'leaderboard.col.rank': '#',
  'leaderboard.col.name': 'Nome',
  'leaderboard.col.score': 'Score',
  'leaderboard.turnstileMissing': 'Falta validar que não és bot. Aguarda o widget.',
  'leaderboard.error.rateLimited': 'Demasiados pedidos — espera 1 minuto.',
  'leaderboard.error.turnstile': 'Validação anti-bot falhou. Tenta outra vez.',
  'leaderboard.error.duplicate': 'Este jogo já foi submetido.',
  'leaderboard.error.replay': 'O log de acções é inválido.',
  'leaderboard.error.dailyQuota': 'API atingiu o limite diário — volta amanhã.',
  'leaderboard.error.notFinished': 'Só podes submeter quando o jogo terminar.',
  'leaderboard.notQualified': 'Score insuficiente para o top {size}.',

  // hours label
  'hours.always': '24h',
  'hours.range': '{open}h-{close}h',
} satisfies Record<string, string>;

export type Translations = typeof ptPT;
export type TranslationKey = keyof Translations;
